import angular from 'angular';

angular.module('cloudX').directive('cxConfigSection', [
  function() {
    return {
      restrict: 'E',
      template: require('./configSection.html'),
      replace: true,
      scope: {
        section: '=',
        fields: '=',
        configs: '=',
      },
      controller: 'ConfigSectionCtrl',
    };
  },
]);
